import { render, staticRenderFns } from "./cookies.vue?vue&type=template&id=3c1fa4a7&scoped=true"
import script from "./cookies.vue?vue&type=script&lang=js"
export * from "./cookies.vue?vue&type=script&lang=js"
import style0 from "./cookies.vue?vue&type=style&index=0&id=3c1fa4a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1fa4a7",
  null
  
)

export default component.exports